<template>
  <v-autocomplete
    :items="timezones"
    item-text="description"
    item-value="name"
    hide-details="auto"
    :label="$t('administration.users.field.timezone')"
    :value="value"
    @input="input"
    outlined
    dense
  />
</template>

<script>
  import { TimeZoneHelper } from '@shared/helpers/timezone';

  export default {
    props: {
      value: {
        type: [String, Number],
        default: null
      }
    },

    computed: {
      timezones: function() {
        return TimeZoneHelper.getList();
      }
    },

    methods: {
      input(val) {
        this.$emit('input', val);
      },
      on_open_change: function(is_open) {
        if (is_open) {
          try {
            const $select = this.$refs.select.$el;
            const $dropdown = $select.getElementsByClassName('ivu-select-dropdown')[0];
            const elements = $select.getElementsByClassName('ivu-select-item-selected');

            if (elements.length) {
              this.$nextTick(() => {
                $dropdown.scrollTop = elements[0].offsetTop;
              });
            }
          } catch (e) {
            console.error(e);
          }
        }
      }
    }
  };
</script>
